module.exports = __webpack_public_path__ + "static/Arnosante-bd99389768531ace8bff204475e41a84.jpg";